import { useState } from 'react'
import Logo from '../assets/La-lepre-neg-logo-header.png'
import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";
import Wa from '../assets/svg/wa.svg?react'
import Button from './Button';

function Header() {
  const { t, i18n, parse, directusGlobals } = useGlobal();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  return (
    <>
      <header className="header w-full bg-white shadow-sm relative z-50">
        <div className="header__container container mx-auto px-4">
          {/* Desktop Navigation */}
          <nav className="header__nav header__nav--desktop hidden md:flex justify-between items-center py-4">
            {/* Logo Left */}
            <div className='header__logo-wrapper relative flex flex-col items-start'>
              <a href="/" className='header__logo-link absolute w-full h-full' ></a>
              <img
                src={Logo}
                alt="La Lepre ceramica Logo"
                className="header__logo-image w-24 h-24 object-contain"
                height="96"
                width="96"
              />
            </div>

            {/* Right nav links */}
            <div className="header__nav-section header__nav-section--right flex justify-end items-center flex-1 space-x-8">
              <a href="#blog" className="header__nav-link font-family-header text-secondary-700 text-xl"></a>
              <a href="#courses" className="header__nav-link font-display font-extralight text-secondary-500 text-xl">{t("menu_courses")}</a>
              <button onClick={() => changeLanguage('en')} className="header__lang-button header__lang-button--en font-display font-extralight text-secondary-500 text-xl cursor-pointer">EN</button>
              <button onClick={() => changeLanguage('it')} className="header__lang-button header__lang-button--it font-display font-extralight text-secondary-500 text-xl cursor-pointer">IT</button>
              <Button
                href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`}
                size="medium"
                data-umami-event="Contact Button - Whatsapp"
                data-umami-event-name="Header"
              >
                {t("menu_contact")}
                <Wa className="ml-2 h-5 w-5 fill-current" />
              </Button>
            </div>
          </nav>

          {/* Mobile Navigation */}
          <nav className="header__nav header__nav--mobile md:hidden flex justify-between items-center py-4">
            {/* Mobile logo (clickable) */}
            <button
              onClick={toggleMobileMenu}
              className="header__mobile-toggle text-2xl flex items-center"
            >
               <img
                src={Logo}
                alt="La Lepre Logo"
                className="header__mobile-logo h-12 w-12 object-contain"
              />
            </button>

            {/* Contact link (always visible on mobile) */}
            <Button href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`} size="small"
              data-umami-event="Button - Whatsapp"
              data-umami-event-name="Header Mobile">
              Contact
              <Wa className="ml-2 h-5 w-5 fill-current" />
            </Button>
          </nav>
        </div>
      </header>

      {/* Mobile Menu Overlay
      {isMobileMenuOpen && (
        <div className="header__mobile-overlay fixed inset-0 bg-white z-60 md:hidden">
          <div className="header__mobile-container container mx-auto px-4 py-4">
            <div className="header__mobile-header flex justify-between items-center mb-8">
              <button
                onClick={toggleMobileMenu}
                className="header__mobile-close text-gray-600 hover:text-gray-900 text-2xl"
              >
                ×
              </button>
            </div>
            <nav className="header__mobile-nav flex flex-col space-y-6">
              <a
                href="#work"
                className="header__mobile-link text-2xl text-gray-600 hover:text-gray-900 transition-colors"
                onClick={toggleMobileMenu}
              >
                Work
              </a>
              <a
                href="#about"
                className="header__mobile-link text-2xl text-gray-600 hover:text-gray-900 transition-colors"
                onClick={toggleMobileMenu}
              >
                About
              </a>

              <Button href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`} size="small"
                data-umami-event="Button - Whatsapp"
                data-umami-event-name="Header Mobile">
                Contact
                <Wa className="ml-2 h-5 w-5 fill-current" />
              </Button>
            </nav>
          </div>
        </div>
      )}
      */}
    </>
  )
}

export default Header
